import React, { memo } from "react";
import { View, StyleSheet, TouchableOpacity, Image } from "react-native";
import Text from "../Text";
import { Colors } from "../../configs";
import ButtonLinear from "../Buttons/ButtonLinear";
import locales_es from "../../locales/es";
import Layout from "../Layout/Layout";
import EditIcon from '../../assets/img/warning.svg';


interface ModalInfoProps {
  title: string;
  message: string;
  action: any;
  onPressDefault: any;
  width?: number | string;
  cancelAction?: any;
  okText?: string;
  cancelText?: string;
}

const ModalActionSingleButton = memo((props: ModalInfoProps) => {
  const {
    title,
    message,
    action,
    onPressDefault,
    width = "60%",
    cancelAction,
    okText
  } = props;

  // Función para cerrar el modal
  const handleClose = () => {
    if (cancelAction) {
      cancelAction();
    }
    onPressDefault();
  };

  return (
    <View style={styles.container}>
      <Layout
        style={{
          borderRadius: 16,
          paddingHorizontal: 24,
          paddingVertical: 32,
          width: width,
          position: "relative", // Necesario para posicionar la "X"
        }}
      >
        {/* Botón X en la parte superior derecha */}
        <TouchableOpacity style={styles.closeButton} onPress={handleClose}>
          <Text size={20} color={Colors.Black} bold>✕</Text>
        </TouchableOpacity>

        {/* Imagen en el medio del modal */}
        <View style={styles.imageContainer}>
         <Image
  // Probamos con una imagen externa conocida
 source={EditIcon}
  style={styles.warningImage}
  resizeMode="contain"
/>
        </View>

        <Text center size={17} lineHeight={20} bold>
          {title}
        </Text>

        <Text center size={13} lineHeight={22} marginTop={16}>
          {message}
        </Text>


      </Layout>
    </View>
  );
});

export default ModalActionSingleButton;

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.Black68,
    ...StyleSheet.absoluteFillObject,
    paddingHorizontal: 24,
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    zIndex: 100,
    width: "100%",
  },
  closeButton: {
    position: "absolute",
    top: 16,
    right: 16,
    zIndex: 10,
    padding: 8, // Área táctil generosa para facilitar el toque
  },
  imageContainer: {
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 16,
    marginTop: 12, // Espacio para que no choque con la X
  },
  warningImage: {
    width: 64, // Ajusta estos valores según el tamaño original de tu imagen
    height: 64,
    borderRadius: 8, // Opcional: si la imagen es cuadrada y quieres redondearla un poco
  },
  centerButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 24,
    marginLeft: "2.5%",
    alignItems: "center",
    width: "100%",
  },
});